//semibold, medium, light, regular
const semiboldPoppins = require('./Poppins-SemiBold.ttf')
const mediumPoppins = require('./Poppins-Medium.ttf')
const lightPoppins = require('./Poppins-Light.ttf')
const regularPoppins = require('./Poppins-Regular.ttf')
const regularPoppinsItalic = require('./Poppins-Italic.ttf')
const mediumPoppinsItalic = require('./Poppins-MediumItalic.ttf')
const lightPoppinsItalic = require('./Poppins-LightItalic.ttf')

export {
  semiboldPoppins,
  mediumPoppins,
  lightPoppins,
  regularPoppins,
  regularPoppinsItalic,
  mediumPoppinsItalic,
  lightPoppinsItalic,
}
